var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('asc-header',{staticClass:"asc-report-title",attrs:{"value":_vm.value,"size":"h1","uppercase":""}})}
var staticRenderFns = []

export { render, staticRenderFns }